export default "__VITE_ASSET__s889dx$6__"